// extracted by mini-css-extract-plugin
export default {"image":"D0EwJe","wrapper":"yOJaYY"};